// extracted by mini-css-extract-plugin
export default {"countryWrapper":"LeagueFixtures_countryWrapper__S2Rjz","headerTittle":"LeagueFixtures_headerTittle__vUiCv","roundWrapper":"LeagueFixtures_roundWrapper__slWip"};